import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { hsaAnswer } from "../hsa-answer";
import { HsaAnswerValidationErrorCode } from "../hsa-answer-validate";

export enum HsaSubmitAnswerStatus {
  OK = "ok",
  VALIDATION_ERROR = "validation_error",
}

const hsaAnswerValidationErrorCodeSchema = createEnum(
  HsaAnswerValidationErrorCode,
  { enumName: "HsaAnswerValidationErrorCode" },
);

const hsaAnswerValidationErrorWire = z.object({
  code: hsaAnswerValidationErrorCodeSchema,
  questionHandle: z.string().min(1),
  message: z.string(),
});

export const submitHsaAnswerInput = z.object({
  sessionToken: z.string().uuid(),
  answer: hsaAnswer,
});

// Validation errors come back in the response (not as an RPC failure) so
// the client can render inline field errors. The client mirrors the same
// validators (from `hsa-common`) for instant feedback; the server is the
// authority.
export const submitHsaAnswerOutput = z.discriminatedUnion("status", [
  z.object({ status: z.literal(HsaSubmitAnswerStatus.OK) }),
  z.object({
    status: z.literal(HsaSubmitAnswerStatus.VALIDATION_ERROR),
    errors: z.array(hsaAnswerValidationErrorWire).min(1),
  }),
]);
